export const shouldRenderLockIcon = ({
  shouldShowLockIconForNonMembers,
  isPrivate,
  isAdmin = false,
}) => !isAdmin && isPrivate && shouldShowLockIconForNonMembers;
